import React from 'react';
import s from './PendingDot.module.css';

/**
 * Small cyan dot shown next to a record that has local-only changes not yet
 * acknowledged by Firestore. The pending state is passed in as a prop, which
 * keeps the dot presentational and avoids reading the status through a
 * context ref, which would go stale.
 *
 * Usage: `<PendingDot pending={lesson.pendingWrite} />`
 *
 * The flag is `pendingWrite` (#407): `spreadRow` in
 * `data/useCollectionWindow.js` and `data/useStoredDocument.js` set it from
 * the overlay, and on a calendar occurrence `occurrencesBetween` in
 * `domain/schedule.js` stamps it, where a series' pending state and its
 * override's meet. `hooks/useCalendarOccurrences.js` carries it flat onto the
 * rows the calendar's cards draw (`test/ui/calendarPendingWrite.test.jsx`).
 * MMS has no offline editing, so it has no such state (see `SyncChip.jsx`).
 *
 * `PendingDot.module.css` records what the week card's `overflow: hidden`
 * does to the ring.
 */
export default function PendingDot({ pending }) {
  if (!pending) return null;

  return (
    <span className={s.dot} title="Not yet synced to cloud" aria-label="Pending sync" />
  );
}
